module.exports = __webpack_public_path__ + "static/img/p-s4-3.c578c56d.png";